import { useIsAuthenticated } from "@azure/msal-react";
import { msalInstance } from "Auth/authConfig";
import { useGetAuthorizationQuery } from "Services/Authorization";

export const useAuthorization = () => {
  const isAuthenticated = useIsAuthenticated();

  const {
    data: authorizationsResponse,
    isLoading: isLoadingAuthorizations,
    isFetching: isFetchingAuthorizations,
    isSuccess: isSuccessAuthorizations,
    isError: isErrorAuthorizations,
  } = useGetAuthorizationQuery(undefined, {
    skip: !isAuthenticated,
  });

  const { features, user, permissions, scope } = authorizationsResponse ?? {};

  // Get email using MSAL
  const loggedUserEmail = user?.email || msalInstance.getActiveAccount()?.idTokenClaims?.email || "";

  return {
    authorizationsResponse,
    user,
    permissions,
    features,
    isLoadingAuthorizations,
    isFetchingAuthorizations,
    isErrorAuthorizations,
    isSuccessAuthorizations,
    loggedUserEmail,
    scope,
  };
};
